import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { theme } from './styles/theme'
import { store } from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.scss'
import App from './App'
import { injectCSP } from './utils/csp'

if (process.env.NODE_ENV === 'development') {
  // Try to intercept the error overlay module before it loads
  const originalCreateElement = document.createElement
  document.createElement = function (tagName: string, options?: ElementCreationOptions) {
    const element = originalCreateElement.apply(this, [tagName, options])
    if (tagName.toLowerCase() === 'iframe' || tagName.toLowerCase() === 'dialog') {
      // Immediately make it invisible
      element.style.display = 'none'
      element.style.position = 'absolute'
      element.style.top = '-10000px'
      element.style.zIndex = '-1000'
    }
    return element
  }

  // Aggressively override console.error to prevent it from triggering the overlay
  const originalConsoleError = console.error
  console.error = function (...args) {
    if (args[0] && typeof args[0] === 'string') {
      // Filter any React error patterns
      if (
        args[0].includes('React will try to recreate this component tree') ||
        args[0].includes('The above error occurred in the') ||
        args[0].includes('Consider adding an error boundary')
      ) {
        // Don't pass these to the original console.error
        return
      }
    }
    return originalConsoleError.apply(this, args)
  }
}

// Inject CSP before anything else
injectCSP()

// Very simple overlay prevention that doesn't try to modify objects
// Just add some event listeners and CSS
if (process.env.NODE_ENV === 'development') {
  try {
    // Simple event listeners to prevent propagation
    window.addEventListener(
      'error',
      (event) => {
        event.stopImmediatePropagation()
        return true
      },
      true
    )

    window.addEventListener(
      'unhandledrejection',
      (event) => {
        event.stopImmediatePropagation()
        return true
      },
      true
    )

    // Add CSS to hide the overlay
    const style = document.createElement('style')
    style.textContent = `
      #react-error-overlay,
      iframe[title="React DevTools"],
      div[style*="z-index: 2147483647"] {
        display: none !important;
      }
    `
    document.head.appendChild(style)
  } catch (e) {
    console.log('Simple error overlay prevention failed')
  }
}

// Continue with normal app initialization
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// Important: Remove the ErrorBoundary wrapper from here
// This was causing the double-boundary issue
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
)
